<template>
  <div :data-index="index">
    <div>
      <div class="block-story" v-if="d.story">&ldquo;{{ d.story }}&rdquo;</div>
      <div class="block-meta name">{{ d.name }}</div>
      <div class="block-meta age" v-if="d.age">Age {{ d.age }}</div>
      <div class="block-meta location" v-if="d.location">{{ d.location }}</div>
    </div>
    <audio class="audio-module" :id="'audio-'+index" :data-index="index" preload="none">
      <source :src="'./assets/audio/' + d.file_name + '.ogg'" type="audio/ogg">
      <source :src="'./assets/audio/' + d.file_name + '.mp4'" type="audio/mp4">
    </audio>
    <div :data-index="index"
         v-on:click="play(index)" class="button play" :id="'audio-button-'+index">
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.382935 16.97V0.969971L16.3829 8.99637L0.382935 16.97Z" fill="#0A0A0A"/>
      </svg>
    </div>
    <br>
    <div v-on:click="openGallery(d.file_name)" class="button first-person-button" v-if="d.type == 'art-audio'">View art</div>
  </div>
</template>

<script>
  var audioStories, buttons;
  var playSvg = '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.382935 16.97V0.969971L16.3829 8.99637L0.382935 16.97Z" fill="white"/></svg>'
  var pauseSvg = '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.382935" y="0.313721" width="16" height="16" fill="#0A0A0A"/></svg>'
  module.exports = {
    props: ['d', 'index'],
    mounted() {
      audioStories = document.querySelectorAll(".audio-module");
      buttons = document.querySelectorAll(".play");
      for (var i = 0; i < audioStories.length; i++) {
        audioStories[i].onended = function(evt) {
          var el = evt.target
          var id = el.dataset.index;
          var button = document.getElementById('audio-button-'+id);
          button.innerHTML = playSvg;
          var block = document.getElementById('block-'+id);
          button.classList.remove("active");
        };
      }
    },
    methods: {
      play: function(id) {
        // maybe have a timer run around the outside to show how far through the audio you are
        // switch back to play button when audio track is over to signal that you can start it over
        var button = document.getElementById('audio-button-'+id);
        var audioBar1 = document.getElementById('audio-bar-1-'+id);
        var audioBar2 = document.getElementById('audio-bar-2-'+id);
        if (button.classList.contains("active")) {
          button.classList.remove("active");
          button.innerHTML = playSvg;
          document.getElementById('audio-'+id).currentTime = 0;
          document.getElementById('audio-'+id).pause();
          audioBar1.style.transition = "width 1s linear";
          audioBar1.classList.remove("translate");
          audioBar2.style.transition = "width 1s linear";
          audioBar2.classList.remove("translate");
        } else {
          button.classList.add("active");
          for (var i = 0; i < audioStories.length; i++) {
            audioStories[i].pause();
            buttons[i].innerHTML = playSvg;
          }
          var audio = document.getElementById('audio-'+id);
          document.getElementById('audio-'+id).play().then(function(){
            var duration = audio.duration;
            button.innerHTML = pauseSvg;
            audioBar1.style.transition = "width "+ duration +"s linear";
            audioBar1.classList.add("translate");
            audioBar2.style.transition = "width "+ duration +"s linear";
            audioBar2.classList.add("translate");
          });
        }
      },
      openGallery: function(image) {
        var imgOverlay = document.querySelector('.art-overlay');
        imgOverlay.classList.toggle("active");
        var notFeatured = document.querySelector(".art-wrapper.active");
        var featured = document.getElementById('featured-'+image);
        var featuredImage = document.getElementById('featured-image'+image);
        if (notFeatured !== null) { notFeatured.classList.remove("active") };
        featuredImage.src = featuredImage.getAttribute("data-src");
        featured.classList.add("active");
      },
    },
  }
</script>

<style scoped></style>
